import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLang from './common/i18n/en/en.json';
import esLang from './common/i18n/es/es.json';
import frLang from './common/i18n/fr/fr.json';

const resources = {
  en: {
    translation: enLang,
  },
  fr: {
    translation: frLang,
  },
  es: {
    translation: esLang
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;